module.exports = __webpack_public_path__ + "img/click-for-price-infiniti-grid-button.8bb92cad.gif";